import { createSelector } from 'reselect';

const getIntl = (state)=>state.intl
;
var ref;
const getCurrency = createSelector(getIntl, (intl)=>{
    return (ref = intl === null || intl === void 0 ? void 0 : intl.currency) !== null && ref !== void 0 ? ref : undefined;
});
var ref1;
const getCountry = createSelector(getIntl, (intl)=>{
    return (ref1 = intl === null || intl === void 0 ? void 0 : intl.country) !== null && ref1 !== void 0 ? ref1 : undefined;
});
var ref2;
const getLocale = createSelector(getIntl, (intl)=>{
    return (ref2 = intl === null || intl === void 0 ? void 0 : intl.locale) !== null && ref2 !== void 0 ? ref2 : undefined;
});
var ref3;
const getDistanceUnit = createSelector(getIntl, (intl)=>{
    return (ref3 = intl === null || intl === void 0 ? void 0 : intl.distanceUnit) !== null && ref3 !== void 0 ? ref3 : undefined;
});

export { getCountry, getCurrency, getDistanceUnit, getIntl, getLocale };
//# sourceMappingURL=selectors.js.map
